<template>
  <div>
    <div
      class="imgWrap"
      @click="showPhotoSwipe"
      @touchstart="startScroll"
      @touchend="endScroll"
      ref="area"
    >
      <img :src="src" :limitTranslation="false" class="view" />
      <img v-if="!loaded" ref="img" :src="src" @load="loadedImgs" />
      <!--
      <v-photoswipe :isOpen="isOpen" :items="items" :options="options" @close="hidePhotoSwipe"></v-photoswipe>
      -->
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
// import { PhotoSwipe } from "v-photoswipe";

export default {
  name: "ImgSwipe",
  props: {
    src: String
  },
  /*
  components: {
    "v-photoswipe": PhotoSwipe
  },
  */
  data() {
    return {
      isOpen: false,
      options: {
        index: 0,
        shareEl: false
      },
      items: [],
      loaded: false,
      zoom: 1,
      initPosition: 0
    };
  },
  mounted() {},
  methods: {
    showPhotoSwipe() {
      /*
      console.log('[ps] show');
      console.trace();
      console.log(e);
      if (e.target.className.indexOf('pswp') !== -1) {
        return;
      }
      this.$nextTick(() => {
        this.isOpen = true;
      })
      */
    },
    hidePhotoSwipe(e) {
      console.log('[ps] hide');
      console.trace();
      console.log(e);
      this.isOpen = false;
    },
    startScroll(e) {
      let point;
      if (e.touches) {
        point = e.changedTouches[0];
      } else {
        point = e;
      }

      this.initPosition = point.pageY;
    },
    endScroll(e) {
      let point;
      if (e.touches) {
        point = e.changedTouches[0];
      } else {
        point = e;
      }
      if (Math.abs(this.initPosition - point.pageY) < 40) {
        this.showPhotoSwipe();
      }
      
    },
    loadedImgs() {
      this.items.push({
        src: this.src,
        w: this.$refs.img.width,
        h: this.$refs.img.height,
        title: ""
      });

      this.$nextTick(() => {
        console.log("img loaded");
        console.log(this.src);
        this.loaded = true;
        this.$emit("imgLoaded", this.src);
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.imgWrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
img.view {
  margin: 0 auto;
  max-width: 100%;
  max-height: 100%;
  pointer-events: none;
  object-fit: contain;
}
</style>
